import React from 'react';

interface RightArrowProps {
    fill?: string;
}

export const RightArrow = ({ fill = 'currentColor' }: RightArrowProps) => (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_286_1163)">
            <path
                d="M-0.000510917 4.12501L-0.000510982 4.87501L8.04137 4.86339L6.42062 6.48489L6.95087 7.01514L8.67062 5.29539C8.88152 5.08442 9 4.79832 9 4.50001C9 4.2017 8.88152 3.91561 8.67062 3.70464L6.95087 1.98489L6.42062 2.51514L8.01887 4.11339L-0.000510917 4.12501Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_286_1163">
                <rect width="9" height="9" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
